<template>
  <v-row class="mt-3">
    <v-col class="hidden-sm-and-down" cols="1"></v-col>
    <v-col>
      <v-card-title>
        Design years
      </v-card-title>
      <v-col cols="12" sm="12" md="12">
      </v-col>
    </v-col>
    <v-col class="hidden-sm-and-down" cols="1"></v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from "vuex";


export default {
  name: "YearsView",
  components: { },
  computed: {
    ...mapState("project", {
      currentProject: (state) => state.currentProject,
    }),
    ...mapGetters('project', {
      selectedRevision: 'selectedRevision',
    }),
  },
};
</script>

<style scoped>
.v-card__title {
  padding-bottom: unset !important;
}
</style>
